import api from '../lib/utils/apiConfig';

const caseStudyService = {
  getCaseStudies: async (search) => {
    const response = await api.get('/case-studies', { params: { search } });
    return response.data;
  },

  getCaseStudyBySlug: async (slug) => {
    const response = await api.get(`/case-studies/${slug}`);
    return response.data;
  },

  getCaseStudyById: async (id) => {
    const response = await api.get(`/case-studies/id/${id}`);
    return response.data;
  },

  createCaseStudy: async (data) => {
    const response = await api.post('/case-studies', data);
    return response.data;
  },

  updateCaseStudy: async (id, data) => {
    const response = await api.put(`/case-studies/${id}`, data);
    return response.data;
  },

  deleteCaseStudy: async (id) => {
    const response = await api.delete(`/case-studies/${id}`);
    return response.data;
  },

  reorderCaseStudies: async (items) => {
    const response = await api.put('/case-studies/reorder/bulk', { items });
    return response.data;
  }
};

export default caseStudyService;
